<!-- 说明
<empty><template v-slot:title>暂无查询信息~333333</template></empty>
-->
<template>
     <div class="empty tc">
          <img src="@/assets/img/empty.png" alt="">
          <p class="desc">
               <slot name="title">暂无查询信息~</slot>
          </p>
     </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.empty {
     padding: 1rem 0;

     .tp {
          height: 1.04rem;
     }

     .desc {
          color: #999
     }
}
</style>